import { Button } from '@seen/ui'
import type { ReactNode } from 'react'
import {
  type InboxReadFilter,
  READ_FILTER_OPTIONS,
} from '#src/hooks/inbox/useInboxCategoryStore.ts'

interface InboxReadFilterTabsProps {
  readFilter: InboxReadFilter
  onReadFilterChange: (filter: InboxReadFilter) => void
}

export function InboxReadFilterTabs({
  readFilter,
  onReadFilterChange,
}: InboxReadFilterTabsProps): ReactNode {
  return (
    <div className="flex gap-0.5">
      {READ_FILTER_OPTIONS.map((option) => (
        <Button
          key={option.value}
          variant="ghost"
          size="xs"
          selected={readFilter === option.value}
          onClick={() => onReadFilterChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  )
}
